import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Presskit from './pages/Presskit';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/presskit" element={<Presskit />} />
      </Routes>
    </Router>
  );
}

export default App;